import { Twitter, Instagram, Linkedin } from "lucide-react";
import { Wordmark } from "./Nav";
import { scrollToId } from "../../lib/scroll";

const COLS = [
  {
    title: "Product",
    links: [
      ["Features", "#features"],
      ["Projects", "#projects"],
      ["Pricing", "#pricing"],
      ["Business", "#business"],
      ["FAQs", "#faqs"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "#top"],
      ["Contact", "#contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Terms of Service", "/terms"],
      ["Cookie Policy", "/cookies"],
    ],
  },
];

export const Footer = () => (
  <footer className="bg-diem-ink border-t border-white/10 pt-20 pb-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Wordmark dark className="h-12" />
          <p className="mt-4 text-white/50 text-sm leading-relaxed max-w-xs">
            Messaging that remembers. Available on iPhone and Android.
          </p>
          <div className="mt-6 flex gap-3">
            {[Twitter, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#top" onClick={(e) => e.preventDefault()} aria-label="Social link (coming soon)"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/50 hover:text-white hover:border-diem-sky/60 transition-colors duration-300">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-5">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    onClick={(e) => { if (href.startsWith("#")) { e.preventDefault(); scrollToId(href); } }}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm font-medium text-white/60 hover:text-white transition-colors duration-300"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/40 mb-5">Get Deyem</p>
          <button onClick={() => scrollToId("#waitlist")} data-testid="footer-waitlist-cta"
            className="rounded-full bg-diem-blue text-white text-sm font-semibold px-6 py-3 shadow-[0_10px_28px_rgba(0,85,255,0.45)] hover:-translate-y-0.5 active:scale-[0.98] transition-[box-shadow,transform] duration-300">
            Join the waitlist
          </button>
          <p className="mt-4 text-[12px] text-white/35">Available on iPhone and Android.</p>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-[13px] text-white/40">© Deyem. All rights reserved.</p>
        <p className="text-[13px] text-white/30 font-display font-medium tracking-tight">Send me a Deyem.</p>
      </div>
    </div>
  </footer>
);
